export const TOKEN_CLIENT_LOCAL_STORAGE_NAME = 'jaylong-client-token';
export const ORGANIZATION_ID = 'jaylong-organization-id';
export const FACILITY_NAME = 'jaylong-facility-name';
export const ADMIN_ROLE = 'admin';

export const STATUS_CODE_UNAUTHORIZED = 401;
export const STATUS_CODE_404 = 404;
